/**
 * Re-check allowance, derived from R3 `transitions`.
 *
 * Every Validate click that the server accepts journals one `revalidate_requested` transition. The cap is the MSA
 * setting `revalidate_max_per_task` (`MSA_REVALIDATE_MAX_PER_TASK`, default 5); R3 does not expose it yet, so this is a
 * constant kept in step with that default. When R3 grows a `revalidations_left` field this module is the only place to
 * switch to it.
 */
import type { TransitionView } from "@/services/multi-agent/laneV2/types";

/** MSA `revalidate_max_per_task` default. */
export const RECHECK_CAP = 5;

/** The transition event an accepted Validate click journals (MSA `core/enums.py`). */
const REVALIDATE_EVENT = "revalidate_requested";

/** How many re-checks remain for this task (never negative). */
export function rechecksLeft(transitions: readonly TransitionView[] | null | undefined): number {
  const used = (transitions ?? []).filter((t) => t.event === REVALIDATE_EVENT).length;
  return Math.max(0, RECHECK_CAP - used);
}

export function rechecksLeftText(left: number): string {
  return left <= 0 ? "No re-checks left" : `${left} of ${RECHECK_CAP} re-checks left`;
}
